import { memo } from 'react';

import { cn } from '../../lib/styles';

interface ListRowRootProps extends React.ComponentProps<'div'> {
  /** Drops the divider on the final row. */
  isLast?: boolean;
}

interface ListRowPartProps extends React.ComponentProps<'div'> {}

const ListRowRoot = memo(({ isLast, className, children, ...rest }: ListRowRootProps) => (
  <div
    className={cn('@container group/list-row px-4 transition-colors hover:bg-bg-sur-secondary', className)}
    {...rest}
  >
    <div
      className={cn(
        'relative flex flex-wrap items-center justify-between gap-2 py-4',
        !isLast && 'border-b border-border-tertiary',
      )}
    >
      {children}
    </div>
  </div>
));

const ListRowContent = memo(({ className, children, ...rest }: ListRowPartProps) => (
  <div
    className={cn(
      'grid min-w-0 flex-1 grid-cols-1 items-center gap-2 @min-[400px]:grid-cols-[minmax(0,1fr)_auto]',
      className,
    )}
    {...rest}
  >
    {children}
  </div>
));

const ListRowPrimary = memo(({ className, children, ...rest }: ListRowPartProps) => (
  <div className={cn('min-w-0 line-clamp-2 font-body-md text-text-primary', className)} {...rest}>
    {children}
  </div>
));

const ListRowTrailing = memo(({ className, children, ...rest }: ListRowPartProps) => (
  <div className={cn('flex shrink-0 flex-wrap items-center gap-2 @min-[400px]:flex-nowrap', className)} {...rest}>
    {children}
  </div>
));

export const ListRow = {
  Root: ListRowRoot,
  Content: ListRowContent,
  Primary: ListRowPrimary,
  Trailing: ListRowTrailing,
};
